export const rotaJuridico = [
  {
    path: "/juridico/civil",
    name: "Processo Civil",
    component: () => import("@/views/Juridico/JuridicoListaProcessos.vue"),
    meta: {
      obraObrigatoria: true,
      breadcrumb: "Dashboard",
      title: "Processo Civil",
      icon: "mdi-scale-balance",
      subject: ["ProcessoJuridico"],
      showMenu: true,
      grupo: "Jurídico",
      grupoTitle: "Jurídico",
    },
  },
  {
    path: "/juridico/trabalhista",
    name: "Processo Trabalhista",
    component: () => import("@/views/Juridico/JuridicoListaProcessos.vue"),
    meta: {
      obraObrigatoria: true,
      breadcrumb: "Dashboard",
      title: "Processo Trabalhista",
      icon: "mdi-briefcase-outline",
      subject: ["ProcessoJuridico"],
      showMenu: true,
      grupo: "Jurídico",
      grupoTitle: "Jurídico",
    },
  },
  {
    path: "/juridico/dashboard",
    name: "Dashboard Juridico",
    component: () => import("@/views/Juridico/JuridicoDashboard.vue"),
    meta: {
      obraObrigatoria: true,
      breadcrumb: "Dashboard",
      title: "Dashboard Jurídico",
      icon: "mdi-briefcase-outline",
      subject: ["ProcessoJuridico"],
      action: ["edit"],
      showMenu: true,
      grupo: "Jurídico",
      grupoTitle: "Jurídico",
    },
  },

  {
    path: "/juridico/enviarDocumentos/:tipoDocumento",
    name: "trabalhista",
    component: () => import("@/views/Juridico/components/JuridicoListaDocumentos.vue"),
    meta: {
      obraObrigatoria: true,
      breadcrumb: "Dashboard",
      title: "Jurídico documentos",
      icon: "mdi-file-document-edit",
      showMenu: false,
      grupo: "Jurídico",
      grupoTitle: "Jurídico",
    },
  },
];
